import React from 'react'
import styled from '@emotion/styled'

const Wrapper = styled.div`
  margin: 0 0 2em 0;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  span {
    margin: 0 0.5rem;
  }
`

const Date = styled.p`
  display: inline-block;
  color: gray;
`

const ReadingTime = styled.p`
  display: inline-block;
`

const Title = styled.h2`
font-size: 2em;
// font-weight: 500;
font-family: ${props => props.theme.fonts.title};
// margin: 0 0 0rem 0;
@media screen and (max-width: ${props => props.theme.responsive.medium}) {
  font-size: 1.8em;
  line-height: 1.2;
}
`

const PostDetails = props => {
  return (
    <Wrapper>
      <Title>{props.title}</Title>
      <Date>{props.date}</Date>
    </Wrapper>
  )
}

export default PostDetails
